exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".remover {\r\n  color: crimson;\r\n}\r\n\r\n.remover:hover {\r\n  font-size: 1.3em;\r\n  color: black;\r\n  cursor: default;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/roteiro/listar-roteiro-interno/listar-roteiro-interno.component.css
// module id = ../../../../../src/app/roteiro/listar-roteiro-interno/listar-roteiro-interno.component.css
// module chunks = main